import {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection, splitDateTime } from "@saleor/misc";
import { UserOperatePageEvent_userOperatePageEvent_edges_node } from "@saleor/pageManage/types/UserOperatePageEvent";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

interface PageEventListProps extends ListProps {
  pageEvent: UserOperatePageEvent_userOperatePageEvent_edges_node[];
}

const numberOfColumns = 6;
const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      default: {
        width: 150,
        textAlign: "center",
        wordBreak: "break-all"
        // overflow: "hidden", // 超出的文本隐藏
        // textOverflow: "ellipsis", // 溢出用省略号显示
        // whiteSpace: "nowrap" // 溢出不换行
      },
      email: {
        width: 200,
        wordBreak: "break-all"
      },
      languageCode: {
        width: 150,
        textAlign: "center",
        wordBreak: "break-all"
      },
      url: {
        width: 250,
        wordBreak: "break-all"
      },
      title: {
        width: 250,
        wordBreak: "break-all"
      }
    }
  }),
  { name: "PageEventList" }
);
export const PageEventList: React.FC<PageEventListProps> = ({
  pageEvent,
  settings,
  pageInfo,
  disabled,
  onNextPage,
  onPreviousPage,
  onUpdateListSettings
}) => {
  const classes = useStyles({});

  return (
    <ResponsiveTable>
      <TableHead>
        <TableCellHeader className={classes.default}>
          <FormattedMessage defaultMessage=" Email" />
        </TableCellHeader>
        <TableCellHeader className={classes.default}>
          <FormattedMessage defaultMessage=" Operate Type" />
        </TableCellHeader>
        <TableCellHeader className={classes.url}>
          <FormattedMessage defaultMessage=" Release Url" />
        </TableCellHeader>
        <TableCellHeader className={classes.title}>
          <FormattedMessage defaultMessage=" Template Title" />
        </TableCellHeader>
        <TableCellHeader className={classes.default}>
          <FormattedMessage defaultMessage=" Event Date" />
        </TableCellHeader>
        <TableCellHeader className={classes.languageCode}>
          <FormattedMessage defaultMessage=" language" />
        </TableCellHeader>
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(pageEvent, pe => (
          <TableRow>
            <TableCell className={classes.default}>
              {maybe(() => (pe ? pe.email : <Skeleton />))}
            </TableCell>
            <TableCell className={classes.default}>
              {pe ? pe.operateType : <Skeleton />}
            </TableCell>
            <TableCell className={classes.url}>
              {pe ? pe.releaseUrl : <Skeleton />}
            </TableCell>
            <TableCell className={classes.title}>
              {pe ? pe.template?.title : <Skeleton />}
            </TableCell>
            <TableCell className={classes.default}>
              {pe ? (
                // <Typography variant="caption">
                //   <DateTime date={order.created} />
                // </Typography>
                splitDateTime(maybe(() => pe.eventDate, "")).date +
                " " +
                splitDateTime(maybe(() => pe.eventDate, "")).time
              ) : (
                <Skeleton />
              )}
            </TableCell>
            <TableCell className={classes.languageCode}>
              {pe ? pe.languageCode : <Skeleton />}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </ResponsiveTable>
  );
};
export default PageEventList;
